import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import { theme } from '_constants/theme';
import { ROUTES } from '_constants/routes';
import { ICONS_ALIASES } from '_constants/icons';

import { refreshSearch, refreshPage } from '_redux/search/slice';
import { selectSearch } from '_redux/search/selector';

import Icon from '_components/atomic/Icon';
import Input from '_components/atomic/Input';

const { colors } = theme;

const StyledSearchItem = styled.div``;

const SearchItem = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const search = useSelector(selectSearch);

  const handleClick = useCallback(
    (event) => {
      event.preventDefault();
      dispatch(refreshPage('1'));
      router.push({
        pathname: ROUTES.search,
        query: { text: search },
      });
    },
    [dispatch, router, search]
  );

  const handleChange = useCallback(
    (event) => {
      dispatch(refreshSearch(event.target.value));
    },
    [dispatch]
  );

  return (
    <StyledSearchItem>
      <Input
        placeholder="Trademark Search"
        value={search}
        onChange={handleChange}
        borderColor={colors.blue[100]}
        textColor={colors.gray[500]}
        color={colors.blue[25]}
        hoverColor={theme.colors.blue[25]}
        hoverTextColor={theme.colors.blue[500]}
        width="135px"
        prefix={
          <div onClick={handleClick}>
            <Icon alias={ICONS_ALIASES.search} color={colors.blue[500]} />
          </div>
        }
        onKeyPress={(event) => {
          if (event.key === 'Enter') {
            handleClick(event);
          }
        }}
      />
    </StyledSearchItem>
  );
};

export default SearchItem;
